import { getSkill } from '../shared/skills';
import { FACTIONS } from '../shared/factions';
import { getUiSoundPlayer } from './ui-sounds';
import type { FactionId } from '../shared/types';

export function showUnlockCelebration(
  container: HTMLElement,
  skillIds: string[],
  onDismiss: () => void,
): void {
  if (skillIds.length === 0) {
    onDismiss();
    return;
  }
  const root = document.createElement('div');
  root.className = 'unlock-celebration';

  const cards = skillIds.map(id => {
    const skill = getSkill(id);
    if (!skill) return '';
    const faction = skill.faction === 'builtin'
      ? { emoji: '✨', displayName: '基礎', colorPrimary: 0xffd54f }
      : FACTIONS[skill.faction as FactionId];
    return `
      <div class="unlock-card">
        <div class="unlock-emoji">${faction.emoji}</div>
        <div class="unlock-title">新技能解鎖!</div>
        <div class="unlock-skill-name">${skill.displayName}</div>
        <div class="unlock-skill-desc">${skill.description}</div>
      </div>
    `;
  }).join('');

  root.innerHTML = `
    ${cards}
    <button class="primary-btn" id="dismiss-unlock">繼續</button>
  `;
  container.appendChild(root);
  getUiSoundPlayer().play('unlock-fanfare', 0.5);

  const finish = (): void => {
    root.remove();
    onDismiss();
  };
  root.querySelector('#dismiss-unlock')!.addEventListener('click', finish);
  // Auto-dismiss after 5s if user doesn't click
  setTimeout(finish, 5000);
}
